<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.searchKey"
              :placeholder="
                $l('from_label_chaxunch') ||
                  '流水号名称/增长方式/流水号类型/日期格式/特殊前缀/单据前缀/数字长度/总长度/有效状态搜索……'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('openEditFormDialog', { type: 'add' })"
              v-if="allow('A')"
            >
              <!-- <b-icon-plus></b-icon-plus> -->
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="700px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small">
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_serial_number_name') || '流水号名称'"
            >
              <el-input
                v-model.trim="form.serialName"
                :placeholder="
                  $l('form_label_pe_serial_number_name') || '请输入流水号名称'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_growth_pattern') || '增长方式'"
            >
              <el-select
                v-model="form.isAddType"
                filterable
                clearable
                style="width:100%"
              >
                <el-option
                  :label="$l('form_label_ progressive_increase') || '递增'"
                  value="A"
                />
                <el-option
                  :label="$l('form_label_day_progressive_increase') || '日递增'"
                  value="B"
                />
                <el-option
                  :label="
                    $l('form_label_month_progressive_increase') || '月递增'
                  "
                  value="C"
                />
                <el-option
                  :label="
                    $l('form_label_ year_progressive_increase') || '年递增'
                  "
                  value="D"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_serial_number_type') || '流水号类型'"
            >
              <el-select
                filterable
                v-model="form.serialType"
                :placeholder="
                  $l('form_label_pleaseEnter_serial_number_type') ||
                    '请选择流水号类型'
                "
                clearable
                style="width:100%"
              >
                <el-option label="BILL" value="BILL" />
                <el-option label="ID" value="ID" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('form_label_date_format') || '日期格式'">
              <dict-select
              clearable
              v-model="form.dateType"
              :body="dateTypeParams"
              url="/sys/common/dict/system"
              :placeholder="
                $l('form_label_ps_a_date_format') || '请选择日期格式'
              "
              filterable
            ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_special_prefix') || '特殊前缀'"
            >
              <el-input
                v-model.trim="form.specialPrefix"
                :placeholder="
                  $l('form_label_pe_Special_prefix') || '请输入特殊前缀'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item
              :label="$l('form_label_documents_prefix') || '单据前缀'"
            >
              <el-input
                v-model.trim="form.billPrefix"
                :placeholder="
                  $l('form_label_pleaseEnter_documents_prefix') ||
                    '请输入单据前缀'
                "
                clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :sm="{ span: 24 }" :md="{ span: 12 }" :lg="{ span: 12 }">
            <el-form-item :label="$l('INDEX.btn_sure_nable') || '是否启用'">
              <el-col>
                <el-checkbox-group v-model="form.isActive">
                  <el-checkbox label="Y">{{
                    $l('from_radio_yes') || '是'
                  }}</el-checkbox>
                  <el-checkbox label="N">{{
                    $l('from_radio_no') || '否'
                  }}</el-checkbox>
                </el-checkbox-group>
              </el-col>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">{{
          $l('INDEX.btn_cancel_query') || '取消查询'
        }}</el-button>
        <el-button size="small" type="warning" @click="reset">{{
          $l('INDEX.btn_reset_filter') || '重置条件'
        }}</el-button>
        <el-button size="small" type="primary" @click="advquery"
          >{{ $l('INDEX.btn_data_retrieval') || '数据检索' }}}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  searchKey: '',
  isActive: ['Y'],
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      dateTypeParams: { dictType: 'dateType' },
      form: { ...initForm },
    }
  },
  created() {
    this.query()
  },
  methods: {
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.searchKey = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
